<template><div /></template>

<script>
import store from '@/store';
import { DOWNLOAD_DOCUMENT_TYPES } from '@/modules/definitions';
import { toRaw } from 'vue';
import { logWebHrError } from "@/core/logger/log-wrapper";

export default {
  name: 'document-download-module',
  props: {
    downloadingDocumentType: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const params = toRaw(props.params);
    const { tempToken, onboardingId, documentId } = params;

    async function initialize() {
      try {
        await store.dispatch('dispatchSetupAuth', tempToken, onboardingId);

        let res = null;

        switch (props.downloadingDocumentType) {
          case DOWNLOAD_DOCUMENT_TYPES.DOCSIGN: {
            const { fieldId } = params;
            res = await store.dispatch('getDocSignatureFile', {
              onboardingId,
              documentId,
              fieldId,
            });
            break;
          }
          case DOWNLOAD_DOCUMENT_TYPES.FORM: {
            res = await store.dispatch('getFormFiles', {
              onboardingId,
              documentId,
            });
            break;
          }
          default:
            throw new Error('Invalid document type');
        }

        if (!res?.data) {
          throw new Error('No data found');
        }

        downloadFile(res.data, 'file.pdf', 'application/pdf');
      } catch (e) {
        logWebHrError({
          message: 'Failed to initialise at document download module',
          source: 'document-download-module',
          metadata: {
            onboardingId,
            documentId,
          },
          error: e,
        });
        alert(e);
      }
    }
    function downloadFile(data, fileName, fileType) {
      const url = window.URL.createObjectURL(
        new Blob([data], { type: fileType })
      );
      const link = document.createElement('a');
      document.body.append(link);
      link.href = url;
      link.download = fileName;
      link.click();

      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => window.URL.revokeObjectURL(link.href), 7000);
    }
    initialize();
    return;
  },
};
</script>

<style scoped></style>
